import {
  getSchemaUserPublic,
  initialValuesUserPublic,
  getSchemaValidationPassword,
  getSchemaValidationCaptcha,
} from "../schemaValidation";
import { User } from "../model";
import {
  Difference,
  handlerErrors,
  standardizeGraphQLResult,
  UserProfileMutationPayloadFixer,
  toInputUppercase,
  getPrivacyLink,
} from "../../../../helpers/helpers";
import { ApolloError } from "apollo-client";
import { Field, Form, Formik, FormikValues } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile } from "../../../../reducers/auth";
import _ from "lodash";
import Recaptcha from "../../../common/Recaptcha/Recaptcha";
import ModalFieldInfo from "../../../common/ ModalFieldInfo/ModalFieldInfo";
import PasswordModalInfoMatch from "../../../common/PasswordModalInfoMatch/PasswordModalInfoMatch";
import PrivacyPolicy from "../../../common/PrivacyPolicy/PrivacyPolicy";
import DeleteUserButton from "../DeleteUserButton/DeleteUserButton";
import { ObjectSchema } from "yup";
import { RootState } from "../../../../rootReducer";

export const PrivateRegistrationForm = (props: any) => {
  const dispatch = useDispatch();
  const privacyLink = getPrivacyLink("PRIVATE_REGISTRATION");
  let initValues = { ...props.initialValues };
  if (initValues) {
    initValues.confirmEmail = initValues.email;
  }
  const initialValues = props.initialValues
    ? initValues
    : initialValuesUserPublic;
  const action = props.initialValues ? "update" : "create";
  const { onSubmit: mutation, t } = props;
  const [genericError, setGenericError] = useState(null);
  const [fieldInfo, setFieldInfo] = useState(false);
  const [fieldPass, setFieldPass] = useState(false);
  const schemaValidation = props.initialValues
    ? getSchemaUserPublic()
    : (getSchemaUserPublic() as ObjectSchema<any>)
        .concat(getSchemaValidationPassword() as ObjectSchema<any>)
        .concat(getSchemaValidationCaptcha() as ObjectSchema<any>);
  const handleSubmit = (
    initialValues: any,
    values: any,
    { setErrors }: { setErrors: any }
  ) => {
    const changed =
      action === "update"
        ? !_.isEmpty(Difference(values, initialValues))
        : false;
    const formData = User.userPublic(
      action === "update" ? Difference(values, initialValues) : values,
      changed
    );
    props.setSubmitted(true);
    mutation(UserProfileMutationPayloadFixer(action, formData))
      .then((result: any) => standardizeGraphQLResult(result, action))
      .then(() => {
        props.setIsOpen(true);
        if (action === "create") {
          (window as any).dataLayer.push({ event: "registrazione" });
        }
        action === "create"
          ? props.setMessageConfirm("create_user_message")
          : props.setMessageConfirm("update_user_message");
        action === "update" && dispatch(getUserProfile());
      })
      .catch((e: ApolloError) => {
        handlerErrors(e, setErrors, setGenericError);
      });
  };
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isRevealPwdConfirm, setIsRevealPwdConfirm] = useState(false);
  const loggedWith = useSelector((state: RootState) => state.auth.auth_issuer);
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={schemaValidation}
      onSubmit={(value: FormikValues, props: any) =>
        handleSubmit(initialValues, value, props)
      }
      key={"PrivateRegistrationForm"}
      data-testid={"private-form"}
    >
      {({ errors, touched, values, setFieldValue, submitCount }) => (
        <Form autoComplete="off" role="presentation" noValidate>
          <div className="row s CivilForm PrivateRegistrationForm">
            <div className="col-sm-12 col-md-10 offset-md-1">
              <div className={"row mt-5 mb-5"}>
                <div className={"col-lg-12 col-md-12"}>
                  <h2>
                    {action === "create"
                      ? t("registration.header2")
                      : t("registration.header2_update")}
                  </h2>
                  <input type={"hidden"} value={""} name={"role"} />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.name && touched.name && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label className="paragraph-small-fs9" htmlFor="name">
                      {t("registration.name.value")}*
                    </label>
                    <Field
                      name={"name"}
                      id="name"
                      type="text"
                      className={
                        errors.name && touched.name && submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.name && touched.name && submitCount > 0
                          ? "name-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.name.placeholder")}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.name && touched.name && submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"confirmPassword-error"}
                      >
                        {errors.name as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.surname && touched.surname && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label className="paragraph-small-fs9" htmlFor="surname">
                      {t("registration.surname.value")}*
                    </label>
                    <Field
                      name={"surname"}
                      id="surname"
                      type="text"
                      className={
                        errors.surname && touched.surname && submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.surname && touched.surname && submitCount > 0
                          ? "surname-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.surname.placeholder")}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.surname && touched.surname && submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"surname-error"}
                      >
                        {errors.surname as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              {!props.initialValues && (
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <div
                      className={
                        errors.password && touched.password && submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label className="paragraph-small-fs9" htmlFor="password">
                        {t("registration.password.value")}*
                        <button
                          type="button"
                          className={"form-info-button"}
                          aria-label={t("aria.form.info.button")}
                          aria-haspopup="dialog"
                          aria-controls={"password-info-modal"}
                          onClick={() => {
                            setFieldPass(true);
                          }}
                        >
                          <span
                            className="form-icon-info"
                            aria-hidden="true"
                          ></span>
                        </button>
                      </label>

                      <Field
                        autoComplete="new-password"
                        id="password"
                        name={"password"}
                        type={isRevealPwd ? "text" : "password"}
                        className={
                          errors.password && touched.password && submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.password && touched.password && submitCount > 0
                            ? "password-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.password.placeholder")}
                      />
                      <button
                        id={
                          errors.password && touched.password && submitCount > 0
                            ? "invalid-password"
                            : "gc-icon-service-sopralluogo-visualizza-1-col"
                        }
                        type="button"
                        aria-label={
                          isRevealPwd
                            ? t("hide.password.btn.label")
                            : t("show.password.btn.label")
                        }
                        onClick={() =>
                          setIsRevealPwd((prevState) => !prevState)
                        }
                        className={
                          isRevealPwd
                            ? "gc-icon-service-sopralluogo-visualizza-1-col deleted-eye"
                            : "gc-icon-service-sopralluogo-visualizza-1-col"
                        }
                      ></button>
                      {errors.password &&
                      touched.password &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"password-error"}
                        >
                          {errors.password as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div
                      className={
                        errors.confirmPassword &&
                        touched.confirmPassword &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="confirmPassword"
                      >
                        {t("registration.confirmPassword.value")}*
                      </label>
                      <Field
                        name={"confirmPassword"}
                        type={isRevealPwdConfirm ? "text" : "password"}
                        id="confirmPassword"
                        className={
                          errors.confirmPassword &&
                          touched.confirmPassword &&
                          submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.confirmPassword &&
                          touched.confirmPassword &&
                          submitCount > 0
                            ? "confirmPassword-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.confirmPassword.value")}
                      />
                      <button
                        id={
                          errors.password && touched.password && submitCount > 0
                            ? "invalid-password"
                            : "gc-icon-service-sopralluogo-visualizza-1-col"
                        }
                        type="button"
                        aria-label={
                          isRevealPwdConfirm
                            ? t("hide.password.btn.label")
                            : t("show.password.btn.label")
                        }
                        onClick={() =>
                          setIsRevealPwdConfirm((prevState) => !prevState)
                        }
                        className={
                          isRevealPwdConfirm
                            ? "gc-icon-service-sopralluogo-visualizza-1-col deleted-eye"
                            : "gc-icon-service-sopralluogo-visualizza-1-col"
                        }
                      ></button>
                      {errors.confirmPassword &&
                      touched.confirmPassword &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"confirmPassword-error"}
                        >
                          {errors.confirmPassword as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.email && touched.email && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label className="paragraph-small-fs9" htmlFor="email">
                      {t("registration.emailAddress.value")}*
                      <button
                        type="button"
                        className={"form-info-button"}
                        aria-label={t("aria.form.info.button")}
                        aria-haspopup="dialog"
                        aria-controls={"email-info-modal"}
                        onClick={() => setFieldInfo(true)}
                      >
                        <span
                          className="form-icon-info"
                          aria-hidden="true"
                        ></span>
                      </button>
                    </label>
                    <Field
                      name={"email"}
                      id="email"
                      type="email"
                      className={
                        errors.email && touched.email && submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.email && touched.email && submitCount > 0
                          ? "email-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.email.placeholder")}
                      onCopy={(e: any) => e.preventDefault()}
                      onPaste={(e: any) => e.preventDefault()}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.email && touched.email && submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"email-error"}
                      >
                        {errors.email as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.confirmEmail &&
                      touched.confirmEmail &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="confirmEmail"
                    >
                      {t("registration.emailConfirm.value")}*
                    </label>
                    <Field
                      name={"confirmEmail"}
                      id="confirmEmail"
                      type="email"
                      className={
                        errors.confirmEmail &&
                        touched.confirmEmail &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.confirmEmail &&
                        touched.confirmEmail &&
                        submitCount > 0
                          ? "confirmEmail-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.email.placeholder")}
                      onCopy={(e: any) => e.preventDefault()}
                      onPaste={(e: any) => e.preventDefault()}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.confirmEmail &&
                    touched.confirmEmail &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"confirmEmail-error"}
                      >
                        {errors.confirmEmail as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-12">
                  <div
                    className={
                      errors.fiscalCode && touched.fiscalCode && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label className="paragraph-small-fs9" htmlFor="fiscalCode">
                      {t("registration.fiscalCode.value")}*
                    </label>
                    <Field
                      name={"fiscalCode"}
                      id="fiscalCode"
                      onInput={toInputUppercase}
                      type="text"
                      className={
                        errors.fiscalCode &&
                        touched.fiscalCode &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.surname && touched.surname && submitCount > 0
                          ? "fiscalCode-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.fiscalCode.placeholder")}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.fiscalCode &&
                    touched.fiscalCode &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"fiscalCode-error"}
                      >
                        {errors.fiscalCode as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-4 col-md-12">
                  <div
                    className={
                      errors.landlinePhoneNumber &&
                      touched.landlinePhoneNumber &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="landlinePhoneNumber"
                    >
                      {t("registration.phone1.value")}
                    </label>
                    <Field
                      name={"landlinePhoneNumber"}
                      id="landlinePhoneNumber"
                      type="tel"
                      className={
                        errors.landlinePhoneNumber &&
                        touched.landlinePhoneNumber &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.landlinePhoneNumber &&
                        touched.landlinePhoneNumber &&
                        submitCount > 0
                          ? "landlinePhoneNumber-error"
                          : null
                      }
                      placeholder={t("registration.phone1.placeholder")}
                    />
                    {errors.landlinePhoneNumber &&
                    touched.landlinePhoneNumber &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"landlinePhoneNumber-error"}
                      >
                        {errors.landlinePhoneNumber as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-4 col-md-12">
                  <div
                    className={
                      errors.mobilePhoneNumber &&
                      touched.mobilePhoneNumber &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="mobilePhoneNumber"
                    >
                      {t("registration.phone2.value")}*
                    </label>
                    <Field
                      name={"mobilePhoneNumber"}
                      id="mobilePhoneNumber"
                      type="tel"
                      className={
                        errors.mobilePhoneNumber &&
                        touched.mobilePhoneNumber &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.mobilePhoneNumber &&
                        touched.mobilePhoneNumber &&
                        submitCount > 0
                          ? "mobilePhoneNumber-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.phone2.placeholder")}
                    />
                    {errors.mobilePhoneNumber &&
                    touched.mobilePhoneNumber &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"mobilePhoneNumber-error"}
                      >
                        {errors.mobilePhoneNumber as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {genericError && (
            <div className={"row"}>
              <div className={"col-sm-12 col-md-10 offset-md-1"}>
                <div className={"generic-error"}>{genericError}</div>
              </div>
            </div>
          )}
          <div className={"row"}>
            <div className="col-sm-12 col-md-10 offset-md-1">
              <div className="row">
                <div className="col-lg-12 col-md-12 mb-5 mt-5">
                  <h2 className="mb-4">
                    {t("form.privacy.label.title_third_scenario")}
                  </h2>
                  <div className="text-header">
                    <div>
                      <PrivacyPolicy
                        privacyLink={privacyLink}
                        privacyCtaLabel={
                          action === "create"
                            ? t("common.registerBtn")
                            : t("common.updateBtn")
                        }
                        thirdScenario
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={"row"}>
            <div className="col-sm-12 col-md-10 offset-md-1">
              <div className="row">
                <div
                  className={"col-lg-12 col-md-12 form-group checkbox-group"}
                >
                  <div className="form-check abc-checkbox">
                    <Field
                      name={"agreementMarketing"}
                      type="checkbox"
                      className={
                        errors.agreementMarketing &&
                        touched.agreementMarketing &&
                        submitCount > 0
                          ? "form-check-input is-invalid"
                          : "form-check-input"
                      }
                      id={"agreementMarketing"}
                      aria-describedby={
                        errors.agreementMarketing &&
                        touched.agreementMarketing &&
                        submitCount > 0
                          ? "agreementMarketing-error"
                          : null
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="agreementMarketing"
                    >
                      {t("form.privacy.label.first_checkbox")}
                    </label>
                    <div className={"form-check-label"}>
                      {t("form.privacy.label.optional")}
                    </div>
                    {errors.agreementMarketing &&
                    touched.agreementMarketing &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"agreementMarketing-error"}
                      >
                        {errors.agreementMarketing as string}
                      </p>
                    ) : null}
                  </div>
                  <div className="form-check abc-checkbox">
                    <Field
                      name={"agreementProfiling"}
                      type="checkbox"
                      className={
                        errors.agreementProfiling &&
                        touched.agreementProfiling &&
                        submitCount > 0
                          ? "form-check-input is-invalid"
                          : "form-check-input"
                      }
                      id={"agreementProfiling"}
                      aria-describedby={
                        errors.agreementProfiling &&
                        touched.agreementProfiling &&
                        submitCount > 0
                          ? "agreementProfiling-error"
                          : null
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="agreementProfiling"
                    >
                      {t("form.privacy.label.second_checkbox")}
                    </label>
                    <div className="form-check-label">
                      {t("form.privacy.label.optional")}
                    </div>
                    {errors.agreementProfiling &&
                    touched.agreementProfiling &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"agreementProfiling-error"}
                      >
                        {errors.agreementProfiling as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!props.initialValues && (
            <div className={"row"}>
              <div className="col-sm-12 col-md-10 offset-md-1">
                <div className="row">
                  <div className={"col-lg-12 col-md-12"}>
                    <Recaptcha type="recaptcha" name="recaptcha" />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className={"row footer-form-actions"}>
            <div
              className={"col-sm-12 col-md-10 offset-md-1 btn-position"}
              style={{ paddingRight: "17px" }}
            >
              <button
                type="submit"
                onClick={() => props.setSubmitted(true)}
                className={"btn btn-primary"}
              >
                {action === "create"
                  ? t("common.registerBtn")
                  : t("common.updateBtn")}
              </button>
            </div>
          </div>
          {fieldInfo ? (
            <ModalFieldInfo
              setFieldInfo={setFieldInfo}
              isLegacy={props.isLegacy}
              password={fieldPass}
            />
          ) : null}
          {fieldPass ? (
            <PasswordModalInfoMatch
              show={fieldPass}
              onClose={() => setFieldPass(false)}
            />
          ) : null}
          <DeleteUserButton />
        </Form>
      )}
    </Formik>
  );
};
